import React from "react";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";

interface CustomizedSnackbarsProps {
  severity: "success" | "error" | "warning" | "info";
  alertMessage: string;
  isOpen: boolean;
  handleClose: (event: React.SyntheticEvent | Event, reason?: string) => void;
}

export default function CustomizedSnackbars(props: CustomizedSnackbarsProps) {
  const { severity, alertMessage, isOpen, handleClose } = props;

  return (
    <Snackbar
      open={isOpen}
      autoHideDuration={6000}
      onClose={handleClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <Alert
        onClose={handleClose}
        severity={severity}
        variant="filled"
        elevation={6}
        sx={{ width: "100%" }}
      >
        {alertMessage}
      </Alert>
    </Snackbar>
  );
}
